export default "images/20250227-173559.png";